import { h } from "hyperapp";

export const Title = (props, children) => <h1 {...props}>{children}</h1>;
export const SubHeading = (props, children) => <h2 {...props}>{children}</h2>;
export const Paragraphs = (props, children) => <div class="paragraph">{children}</div>;
export const Hr = (props, children) => <hr class="hr" />;
export const Button = (props, children) => (
	<button {...props} class="btn">
		{children}
	</button>
);
export const WalletButton = (props, children) => (
	<a class="addToWalletButton" {...props}>
		{children}
	</a>
);
export const Loading = (props, children) => (
	<div style={{ textAlign: "center", marginTop: "2em", marginBottom: "2em" }}>
		<div
			style={{
				backgroundColor: "rgb(0, 223, 141)",
				width: "16px",
				height: "16px",
				margin: "4px",
				borderRadius: "100%",
				animation: "pulseLoader 0.75s cubic-bezier(0.2, 0.68, 0.18, 1.08) 0.12s infinite both",
				display: "inline-block"
			}}
		/>
		<div
			style={{
				backgroundColor: "rgb(0, 223, 141)",
				width: "16px",
				height: "16px",
				margin: "4px",
				borderRadius: "100%",
				animation: "pulseLoader 0.75s cubic-bezier(0.2, 0.68, 0.18, 1.08) 0.24s infinite both",
				display: "inline-block"
			}}
		/>
		<div
			style={{
				backgroundColor: "rgb(0, 223, 141)",
				width: "16px",
				height: "16px",
				margin: "4px",
				borderRadius: "100%",
				animation: "pulseLoader 0.75s cubic-bezier(0.2, 0.68, 0.18, 1.08) 0.36s infinite both",
				display: "inline-block"
			}}
		/>
	</div>
);
export const Header = (props, childre) => (
	<div
		style={{
			padding: "37px 35px 32px",
			backgroundColor: "#000"
		}}
	>
		<img width="208" height="26" alt="Cabcharge Logo" class="logo" src="public/img/logo-cabcharge-card-screen.svg " />
	</div>
);
